"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIGridConstants = require("./UIGridConstants");

function makeBreakPointsType(range) {
  var rangePropType = _propTypes.default.oneOf(range);

  var screenSizeShapePropType = _propTypes.default.shape(_UIGridConstants.SCREEN_SIZES.reduce(function (shape, screenSize) {
    shape[screenSize] = rangePropType;
    return shape;
  }, {}));

  return _propTypes.default.oneOfType([_propTypes.default.string, // only intended for UIStepIndicator (#1753)
  rangePropType, screenSizeShapePropType]);
}

function breakPointsToClassName(classMap, breakPoints) {
  if (breakPoints == null) return null; // CRM-12024

  if (typeof breakPoints === 'string') {
    return null;
  }

  if (typeof breakPoints === 'number') {
    return classMap.xs[breakPoints];
  }

  return Object.keys(breakPoints).map(function (screenSize) {
    var value = breakPoints[screenSize];
    return "" + classMap[screenSize][value];
  }).join(' ');
}

var _default = _react.default.createClass({
  displayName: "UIGridItem",
  propTypes: {
    children: _propTypes.default.any,
    offset: makeBreakPointsType(_UIGridConstants.OFFSET_RANGE).isRequired,
    size: makeBreakPointsType(_UIGridConstants.OFFSET_RANGE).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      offset: 0
    };
  },
  getClassName: function getClassName() {
    var _this$props = this.props,
        className = _this$props.className,
        offset = _this$props.offset,
        size = _this$props.size;
    return (0, _classnames.default)(className, breakPointsToClassName(_UIGridConstants.OFFSET_CLASSES, offset), breakPointsToClassName(_UIGridConstants.SIZE_CLASSES, size));
  },
  render: function render() {
    var _this$props2 = this.props,
        __offset = _this$props2.offset,
        __size = _this$props2.size,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["offset", "size"]);
    return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
      className: this.getClassName()
    }), this.props.children);
  }
});

exports.default = _default;
module.exports = exports.default;